<div class="heading">
  <div class="width95 txt4">
    <span class="step-name-text">{{model==undefined?"":model.name}}</span>
    <div class="header-icons-container">
      <div class="material-icons icon-head newclass" *ngIf="showSaveButton; else modifyMenu">
        <a><span uk-tooltip="Save" class="material-icons canvasicon myclass" (click)="saveCanvas2()">save</span></a>
      </div>
      <ng-template #modifyMenu>
        <div class="add-iconicon width20 icon-head">
          <a *ngIf="!isEditingStep"><span uk-tooltip="Modify" class="material-icons canvasicon width20 icon-head"
              (click)="modifyStep()">edit</span></a>
          <a *ngIf="isEditingStep"><span uk-tooltip="Back" (click)="modifyStep()"
              class="material-icons canvasicon width20 icon-head">keyboard_backspace</span></a>
          <a><span uk-tooltip="Save in Library" *ngIf="!isEditingStep" class="material-icons canvasicon width20 icon-head"
              (click)="saveAsModel(model)">save_as</span></a>
          <a><span uk-tooltip="Save" class="material-icons canvasicon width20 icon-head"
              (click)="saveCanvasdb2()">save</span></a>
        </div>
      </ng-template>
      <div class="icon-head">
        <a>
          <span
            [attr.uk-tooltip]="showEnglishDescription ? 'Switch to command view' : 'Switch to English description'"
            class="material-icons canvasicon width20 icon-head"
            (click)="toggleEnglishDescriptionView()">
            {{ showEnglishDescription ? 'code' : 'translate' }}
          </span>
        </a>
      </div>
      <span class="close-icon" matTooltip="close" *ngIf="!isModified" s uk-icon="close" (click)="navigateBack()"></span>
    </div>
  </div>
</div>

<!-- Select All Header -->
<div class="select-all-header" *ngIf="ctvList && ctvList.length > 0">
  <div class="select-all-wrapper">
    <mat-checkbox 
      [(ngModel)]="selectAllChecked" 
      (change)="toggleSelectAll()"
      [indeterminate]="isPartialSelection()"
      class="select-all-checkbox">
      <span class="select-all-label">Select All</span>
    </mat-checkbox>
  </div>
</div>

<div class="canvas-list" cdkDropList (cdkDropListEntered)="entered($event)" (cdkDropListExited)="exited($event)"
  (cdkDropListEvent)="sortElements($event)" (CdkDragSortEvent)="moveElement($event)"
  (cdkDropSortEvent)="moveElement($event)" [cdkDropListData]="ctvList" (cdkDropListDropped)="drop($event)" 
  [cdkDropListDisabled]="expandedSnippetCtv !== null"
  (contextmenu)="onCanvasRightClick($event)">
  <ul class="list">
    <li class="box" *ngFor="let ctv of ctvList;let i = index " cdkDrag 
        [cdkDragDisabled]="expandedSnippetCtv !== null"
        (cdkDragStarted)="dragStarted($event, i)" 
        (cdkDragEnded)="dragEnded($event)">
      <ng-container *ngIf="ctv?.deleted==0">
        
        <!-- Checkbox for multi-select - OUTSIDE the command step container -->
        <div class="checkbox-wrapper">
          <mat-checkbox 
            [(ngModel)]="ctv.selected" 
            (change)="onSelectionChange()"
            (click)="$event.stopPropagation()">
          </mat-checkbox>
        </div>

        <ul cdkDropList [cdkDropListData]="ctvList" class="list1" (cdkDropListDropped)="drop2($event)"
          cdkDropListConnectedTo="list-5" 
          [cdkDropListDisabled]="expandedSnippetCtv !== null"
          [ngClass]="{'red-border': ctv.type === 'API', 'inactive-step': ctv.active === false, 'selected-step': ctv.selected, 'pasted-step': ctv.pasted }"
          (contextmenu)="onRightClick($event, i)">

          <li class="box1">
            <span class="block command ellipsis" [class.pe-hidden]="showEnglishDescription">
              <span matTooltip="{{ctv.command.name}}">{{ctv.command.name}}</span>
            </span>

            <div class="block target list gear dragging" style="z-index: 99;" *ngIf="ctv.command.accepts[0]=='target'"
              [ngClass]="{'red-border': ctv.target?.name === '' || ctv.target?.name == null, 'pe-hidden': showEnglishDescription }" cdkDrag
              (cdkDragStarted)="dragStarted($event, i)" (cdkDragEnded)="dragEnded($event)" 
              [cdkDragDisabled]="!ctrlKeyPressed || expandedSnippetCtv !== null"
              (cdkDragEntered)="onDragEntered(i)">
              <div class="ellipsis" [matTooltip]="ctv.target?.name">{{ctv.target?.name}}</div>
              <div class="target-icon">
                <div class="gear-icon" (click)="addNewElement(i,1)">
                  <a>
                    <mat-icon>settings</mat-icon>
                  </a>
                </div>
                <a class="myInput1" *ngIf="ctv.errors?.target && !ctv.errors.target==false">
                  <mat-icon class="myInput3" [matTooltip]="ctv.errors.target">error</mat-icon>
                </a>
                <a class="myInput1" *ngIf="ctv.target?.warnings?.target && !ctv.target.warnings.target==false">
                  <mat-icon class="myInput2" [matTooltip]="ctv.target.warnings.target">warning</mat-icon>
                </a>
              </div>
            </div>

            <div class="block target list " style="z-index: 100;" cdkDropList [cdkDropListConnectedTo]="ObjectList2"
              [cdkDropListData]="ctvList" (cdkDropListDropped)="drop2($event)" 
              [cdkDropListDisabled]="expandedSnippetCtv !== null"
              *ngIf="ctv.command.accepts[1]=='target'"
              [ngClass]="{'red-border': ctv.target2?.name === '' || ctv.target2?.name == null, 'pe-hidden': showEnglishDescription }">
              <div class="ellipsis" [matTooltip]="ctv.target2?.name"> {{ctv.target2?.name}}</div>
              <div class="target-icon">
                <div class="gear-icon" (click)="addNewElement(i,2)">
                  <a>
                    <mat-icon>settings</mat-icon>
                  </a>
                </div>
                <a class="myInput1" *ngIf="ctv.errors?.target2 && !ctv.errors.target2==false">
                  <mat-icon class="myInput2" [matTooltip]="ctv.errors.target2">error</mat-icon>
                </a>
                <a class="myInput1" *ngIf="ctv.target2?.warnings?.target2 && !ctv.target2.warnings.target2==false">
                  <mat-icon class="myInput2" [matTooltip]="ctv.target2.warnings.target2">warning</mat-icon>
                </a>
              </div>
            </div>

            <div class="block value ellipsis myInput security " [matTooltip]="isValue1Secure(ctv) ? 'Secured by ' + brand.brandName : ctv.value"
              [ngClass]="{'red-border': ctv.errors?.value1 && !ctv.errors.value1==false, 'pe-hidden': showEnglishDescription }"
              *ngIf="ctv.command.accepts[0]=='value'||(ctv.command.accepts[0]=='target'&&ctv.command.accepts[1]=='value')">
              <ng-container *ngIf="!getShowInputValue(i); else inlineValueEditor">
                <div class="plain-value" (click)="!isValue1Secure(ctv) && startValueEdit(i)">
                  <ng-container *ngIf="isValue1Secure(ctv); else showPlain">
                    <span class="secure-badge" title="Value is secured">Secured by {{brand.brandName}}</span>
                  </ng-container>
                  <ng-template #showPlain>
                    <span class="ellipsis value-text">{{ctv.value}}</span>
                  </ng-template>
                  <button class="value-action" mat-icon-button type="button" aria-label="Toggle secure" (click)="$event.stopPropagation(); toggleSecure(i)">
                    <mat-icon class="secure-toggle-icon" [ngClass]="{ secured: isValue1Secure(ctv) }">{{ isValue1Secure(ctv) ? 'lock' : 'lock_open' }}</mat-icon>
                  </button>
                </div>
              </ng-container>
              <ng-template #inlineValueEditor>
                <mat-form-field class="inline-editor" appearance="fill">
                  <input matInput [type]="isValue1Secure(ctv) ? 'password' : 'text'" name="value1" [disabled]="isValue1Secure(ctv)" [readonly]="isValue1Secure(ctv)" [tabIndex]="isValue1Secure(ctv) ? -1 : 0"
                    autocomplete="off" autocapitalize="off" autocorrect="off" spellcheck="false"
                    [(ngModel)]="ctv.value" (focus)="!isValue1Secure(ctv) && initParamList(i)" [matAutocomplete]="isValue1Secure(ctv) ? null : auto1"
                    (keydown.enter)="finishValueEdit(i)" (keydown.escape)="cancelValueEdit(i)"
                    (blur)="finishValueEdit(i)">
                  <mat-autocomplete #auto1="matAutocomplete" (optionSelected)="paramFilter($event.option.value, ctv.value, i)">
                    <mat-option *ngFor="let option of ctv.filteredOptions" [value]="option">
                      {{option}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </ng-template>
              <a class="myInput1" *ngIf="ctv.errors?.value1 && !ctv.errors.value1==false">
                <mat-icon class="myInput2" [matTooltip]="ctv.errors.value1">error</mat-icon>
              </a>
            </div>

            <div class="block value ellipsis myInput security" [matTooltip]="isValue2Secure(ctv) ? 'Secured by ' + brand.brandName : ctv.value2"
              [ngClass]="{'red-border': ctv.errors?.value2 && !ctv.errors.value2==false  }"
              *ngIf="ctv.command.accepts[1]=='value'&&ctv.command.accepts[0]=='value'">
              <ng-container *ngIf="!getShowInputValue2(i); else inlineValue2Editor">
                <div class="plain-value" (click)="!isValue2Secure(ctv) && onValue2Clicked(ctv, i)">
                  <ng-container *ngIf="isValue2Secure(ctv); else showPlain2">
                    <span class="secure-badge" title="Value is secured">Secured by {{brand.brandName}}</span>
                  </ng-container>
                  <ng-template #showPlain2>
                    <span class="ellipsis value-text">{{ctv.value2}}</span>
                  </ng-template>
                  <button class="value-action" mat-icon-button type="button" aria-label="Toggle secure" (click)="$event.stopPropagation(); toggleSecure2(i)">
                    <mat-icon class="secure-toggle-icon" [ngClass]="{ secured: isValue2Secure(ctv) }">{{ isValue2Secure(ctv) ? 'lock' : 'lock_open' }}</mat-icon>
                  </button>
                  <mat-icon
                    *ngIf="isTemplateMatchCommand(ctv)"
                    class="template-config-icon"
                    matTooltip="Configure validation template"
                  >tune</mat-icon>
                </div>
              </ng-container>
              <ng-template #inlineValue2Editor>
                <mat-form-field class="inline-editor" appearance="fill">
                  <input matInput [type]="isValue2Secure(ctv) ? 'password' : 'text'" name="value2" [disabled]="isValue2Secure(ctv)" [readonly]="isValue2Secure(ctv)" [tabIndex]="isValue2Secure(ctv) ? -1 : 0"
                    autocomplete="off" autocapitalize="off" autocorrect="off" spellcheck="false"
                    [(ngModel)]="ctv.value2" (focus)="!isValue2Secure(ctv) && initParamList(i)" [matAutocomplete]="isValue2Secure(ctv) ? null : auto2"
                    (keydown.enter)="finishValue2Edit(i)" (keydown.escape)="cancelValue2Edit(i)"
                    (blur)="finishValue2Edit(i)">
                  <mat-autocomplete #auto2="matAutocomplete" (optionSelected)="paramFilter2($event.option.value, ctv.value2, i)">
                    <mat-option *ngFor="let option of ctv.filteredOptions" [value]="option">
                      {{option}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </ng-template>
              <a class="myInput1" *ngIf="ctv.errors?.value2 && !ctv.errors.value2==false">
                <mat-icon class="myInput2" [matTooltip]="ctv.errors.value2">error</mat-icon>
              </a>
            </div>

            <div class="block english-description-block ellipsis" *ngIf="showEnglishDescription"
                 [matTooltip]="getEnglishDescription(ctv)">
              {{ getEnglishDescription(ctv) }}
            </div>

            <!-- Inline controls for toggle and delete -->
            <div class="inline-controls">
              <!-- Toggle switch for Active/Inactive -->
              <div class="toggle-control" 
                   [matTooltip]="ctv.active !== false ? 'Active' : 'Inactive'"
                   (click)="toggleActive(ctv, i)">
                <mat-icon [ngClass]="{'active-icon': ctv.active !== false, 'inactive-icon': ctv.active === false}">
                  {{ ctv.active !== false ? 'toggle_on' : 'toggle_off' }}
                </mat-icon>
              </div>
              <div *ngIf="ctv.command.name === 'verify image snippet' || ctv.command.name === 'assert image snippet'">
                <button class="viewImg" (click)="openSnippet(ctv, $event)" mat-icon-button matTooltip="View Screenshot">
                  <mat-icon>visibility</mat-icon>
                </button>
              </div>
              <!-- Delete icon -->
              <button mat-icon-button 
                      class="delete-control" 
                      type="button" 
                      matTooltip="Delete"
                      (click)="delete(ctv, i)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </li>
        </ul>
      </ng-container>
    </li>
  </ul>
</div>
<div class="snippet-overlay" 
     *ngIf="expandedSnippetCtv" 
     (click)="closeSnippet($event)">
  <div class="snippet-popup" (click)="$event.stopPropagation()">
    <button class="close-btn" (click)="closeSnippet($event)">✕</button>
    <img *ngIf="expandedSnippetCtv.target?.base64_info?.image"
         [src]="expandedSnippetCtv.target.base64_info.image"
         class="snippet-img" />
  </div>
</div>

<!-- Context Menu -->
<div class="context-menu" 
     *ngIf="contextMenuVisible" 
     [style.left.px]="contextMenuX" 
     [style.top.px]="contextMenuY">
  <div class="context-menu-item" (click)="copySelectedSteps()" [class.disabled]="!hasSelectedSteps()">
    <mat-icon>content_copy</mat-icon>
    <span>Copy</span>
  </div>
  <div class="context-menu-item" 
       (click)="pasteSteps()" 
       [class.disabled]="!canPaste()">
    <mat-icon>content_paste</mat-icon>
    <span>Paste</span>
  </div>
   <div class="context-menu-item" 
       (click)="enableSelectedSteps()" 
       [class.disabled]="!hasSelectedSteps() || !hasInactiveSelectedSteps()"
       *ngIf="hasInactiveSelectedSteps()">
    <mat-icon>check_circle</mat-icon>
    <span>Enable</span>
  </div>
  <div class="context-menu-item" 
       (click)="disableSelectedSteps()" 
       [class.disabled]="!hasSelectedSteps() || !hasActiveSelectedSteps()"
       *ngIf="hasActiveSelectedSteps()">
    <mat-icon>block</mat-icon>
    <span>Disable</span>
  </div>
  <div class="context-menu-item" (click)="deleteSelectedSteps()" [class.disabled]="!hasSelectedSteps()">
    <mat-icon>delete</mat-icon>
    <span>Delete</span>
  </div>
</div>

<ng-template #valueEditDialog>
  <div class="dialog-content" role="dialog" aria-label="Enter secure value">
    <button mat-icon-button class="dialog-close" aria-label="Close" (click)="cancelDialog()">
      <mat-icon>close</mat-icon>
    </button>
    <h3 class="dialog-title">Enter value</h3>
    <mat-form-field class="dialog-input" appearance="fill">
      <mat-label>Value</mat-label>
      <input matInput [type]="'password'" name="xpeerValue" autocomplete="off" autocapitalize="off" autocorrect="off" spellcheck="false" [(ngModel)]="dialogValueInput">
    </mat-form-field>
    <div class="dialog-actions">
      <button mat-raised-button color="primary" (click)="applyDialogValue(true)">Secure</button>
      <button mat-stroked-button color="basic" (click)="applyDialogValue(false)">Not secure</button>
    </div>
  </div>
</ng-template>